import React, { Component } from 'react';
import PropTypes from "prop-types";

class Spinner extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className={`spin-cont ${this.props.classAdded}`}>
                <div className="spin" />
            </div>
        );
    }
}

Spinner.propTypes = {
    classAdded: PropTypes.string
};

export default Spinner;
